import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { CuttingFacadeMaterial } from 'cloud-shared-lib';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FacadesService {
  constructor(private http: HttpClient) {}

  getFacadeMaterials(orderId: number): Observable<CuttingFacadeMaterial[]> {
    if (!isNaN(+orderId)) {
      return this.http.get<CuttingFacadeMaterial[]>(ApiLinks.orderFacadeMaterial(orderId));
    } else {
      return of([]);
    }
  }
}
